export function valueInArray(val, array) {
  return array.filter((it) => it === val).length > 0;
}

export function foo() {
  return 'foo';
}
